/**
 * Modern KeyEvent Mapping used for event.key
 */
export const KeyEvent = {
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  End: 'End',
  Enter: 'Enter',
  Escape: 'Escape',
  Home: 'Home',
  Tab: 'Tab',
  PageUp: 'PageUp',
  PageDown: 'PageDown',
  Space: 'Space',
  Backspace: 'Backspace',
  Delete: 'Delete',
};
